export default __webpack_public_path__ + "static/media/goopter-dining-automation-robots-hightlights-features.32c5a7a8.png";